<template>
  <i
    :class="flagClasses"
    :data-cy="`ds-flag--${props.flag}`"
  >
    <component
      :is="flagSvg"
      v-if="!!flagSvg"
      viewBox="0 0 32 24"
    />
  </i>
</template>

<script setup lang="ts">
import { DS_FLAG_SIZES } from "@/src/design_system/primitives/flag/types";
import { computed } from "vue";
import { getSvgComponentLoader } from "@/src/design_system/primitives/flag/utils";
import { DSFlagProps } from "@/src/design_system/primitives/flag/types/props";
import { DS_FLAG_CLASSES } from "@/src/design_system/primitives/flag/constants/classes";

const props = withDefaults(defineProps<DSFlagProps>(), {
  size: DS_FLAG_SIZES.Medium,
});

const flagSvg = computed(() => {
  return getSvgComponentLoader(props.flag);
});

const flagClasses = computed(() => {
  const classes: string[] = [DS_FLAG_CLASSES.Base];
  classes.push(`${DS_FLAG_CLASSES.Base}--${props.size}`);
  return classes;
});
</script>
